export default function WhyNeedsAnalysisMatters() {
  const points = [
    {
      icon: 'ri-megaphone-line',
      title: 'Почему презентация раньше вопросов не работает',
      desc: 'Когда менеджер начинает презентацию до диагностики, он предлагает решение вслепую. Это как врач, выписывающий рецепт без осмотра. Клиент чувствует, что его не слушают, и теряет доверие. В современном мире, где у клиента десятки альтернатив, доверие — единственное конкурентное преимущество.',
    },
    {
      icon: 'ri-eye-off-line',
      title: 'Почему клиенты сами редко говорят настоящую проблему',
      desc: 'Клиент приходит с симптомом, а не с диагнозом. «Нам нужно обучение продажам» — это симптом. Настоящая проблема может быть в отсутствии системы мотивации, некачественных лидах или слабом продукте. Задача менеджера — через вопросы дойти до первопричины. Без этого обучение не даст результата.',
    },
    {
      icon: 'ri-chat-check-line',
      title: 'Почему большинство возражений появляются из-за плохой диагностики',
      desc: '«Дорого», «Я подумаю», «Пришлите КП» — в 70% случаев это не реальные возражения, а следствие того, что менеджер не выявил ценность для клиента. Когда потребность раскрыта глубоко, цена перестаёт быть главным критерием — клиент уже видит, какую проблему решает.',
    },
    {
      icon: 'ri-question-mark',
      title: 'Почему вопрос «Что вас интересует?» практически бесполезен',
      desc: 'Этот вопрос перекладывает работу на клиента. Клиент не обязан формулировать потребность — это задача профессионала. Хороший менеджер задаёт конкретные, направленные вопросы: «Как вы сейчас решаете эту задачу?», «Что вас не устраивает в текущем решении?», «Что изменится, если проблема сохранится?»',
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Почему хорошие вопросы увеличивают доверие',
      desc: 'Когда менеджер задаёт глубокие, продуманные вопросы, клиент чувствует: перед ним эксперт, который понимает его бизнес. Это формирует принципиально другой уровень отношений — не продавец-покупатель, а эксперт-клиент. В таком формате продажа происходит естественно, без давления.',
    },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-flashlight-line"></i>
            Экспертный разбор
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему выявление потребностей — сердце современных продаж
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Продажи изменились. Сегодня недостаточно знать продукт и уметь «закрывать». Клиент покупает только тогда, когда чувствует, что его действительно поняли. Разбираем, почему диагностика стала главным навыком менеджера.
          </p>
        </div>

        <div className="space-y-6 max-w-4xl mx-auto">
          {points.map((item, i) => (
            <div key={i} className="bg-white rounded-2xl p-6 md:p-8 border border-gray-100 hover:border-teal-100 transition-colors group">
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 bg-teal-600/10 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-teal-600/15 transition-colors">
                  <i className={`${item.icon} text-2xl text-teal-600`}></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3">{item.title}</h3>
                  <p className="text-base text-gray-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}